import { moduleProviderFactory } from 'core/providers';
import { TeamsList, TeamsEdit } from 'application/teams/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.teams',
                pattern: '/teams',
                children: [
                    {
                        name: 'master.app.main.teams.list',
                        pattern: '',
                        tabTitle: 'TEAMS.LIST.TITLE',
                        component: TeamsList,
                        data: {
                            title: 'TEAMS.LIST.TITLE'
                        }
                    },
                    {
                        name: 'master.app.main.teams.create',
                        pattern: '/create',
                        tabTitle: 'Create Teams',
                        component: TeamsEdit,
                        authorization: 'portalSection.create',
                        data: {
                            title: 'TEAMS.CREATE.TITLE'
                        },
                    },
                    {
                        name: 'master.app.main.teams.edit',
                        pattern: '/edit/:id',
                        tabTitle: 'Edit Teams',
                        component: TeamsEdit,
                        data: {
                            title: 'TEAMS.EDIT.TITLE'
                        },
                    }                 
                ]
            }
        ],
        menu : [
            {
                title: 'MENU.ADMINISTRATION',
                order: 10,
                icon: 'users',
                subMenu: [
                    {
                        title: 'MENU.TEAMS',
                        route: 'master.app.main.teams.list',
                        order: 4,
                    }
                ]
            }
        ]
    });
})();

